import queryString from 'query-string';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { mergeSyncHealthStateForOrgIdSelector } from '../merge-integration-selectors';

import * as Api from '../../api/api';

export const loadMergeSyncHealth = (orgId: number) =>
  createGenericDispatcher({
    name: 'LOAD_MERGE_SYNC_HEALTH',
    loadFunction: () => Api.get(`/merge/sync-health?${queryString.stringify({ orgId })}`),
    args: { orgId },
    shouldExecuteSelector: (state: any) => mergeSyncHealthStateForOrgIdSelector(state, orgId),
  });
